import { Grid, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';

import CustomButton from '../../designSystem/Button';
import { rutChanger, validaRut } from '../../functions/utils';

const RutBusinessSearcher = (props: any) => {
  const { setBusiness, setSearched, onSimulationSelect } = props;
  const [identifier, setIdentifier] = useState('');
  const [rutValidated, setRutValidated] = useState(false);

  const handleChangeIdentifier = (e: any) => {
    setSearched(false);
    setRutValidated(false);
    rutChanger(e.target.value, setIdentifier);

    if (validaRut(e.target.value)) {
      setBusiness({ identifier: e.target.value });
      setRutValidated(true);
      // NO llamamos a setSearched(true) aquí, solo validamos
    } else {
      setBusiness(null);
      setRutValidated(false);
    }
  };

  const handleSelectClick = () => {
    if (rutValidated) {
      if (onSimulationSelect) {
        onSimulationSelect();
      } else {
        setSearched(true);
      }
    }
  };

  const hasError = identifier.length > 0 && !validaRut(identifier);

  useEffect(() => {
    if (identifier === '') {
      setSearched(false);
      setBusiness(null);
      setRutValidated(false);
    }
  }, []);

  return (
    <div>
      <div style={{ padding: '10px 0px' }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={8}>
            <TextField
              label="RUT"
              placeholder="Sin puntos con guión. Ej: 12345678-K"
              value={identifier}
              color={rutValidated ? 'success' : 'error'}
              fullWidth
              error={hasError}
              helperText={hasError ? 'Ingrese un RUT válido' : ''}
              onChange={(e) => handleChangeIdentifier(e)}
            />
          </Grid>
          <Grid item xs={4} textAlign="center">
            <CustomButton
              color="primary"
              onClick={handleSelectClick}
              disabled={!rutValidated}
            >
              Seleccionar
            </CustomButton>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default RutBusinessSearcher;
